import type { ReactNode } from 'react';
import { brandSegments } from '../../website/src/brand.js';

/**
 * Renders copy with every "ComplyEdge" bold (Leo, 2026-09-28). The matcher is
 * the website's brand.js, shared by all three apps. font-bold, not a bare
 * <strong>: the app.css reset sets strong to font: inherit.
 */
export function withBrand(text: string): ReactNode {
  const parts = brandSegments(text);
  if (!parts.some((p) => p.brand)) return text;
  return parts.map((p, i) =>
    p.brand ? (
      <strong key={i} className="font-bold">
        {p.text}
      </strong>
    ) : (
      p.text
    ),
  );
}
